import { PopoverPlacement, useMediaQuery } from '@execonline-inc/execonline-ui';

function useProgramPopoverPlacement(): PopoverPlacement {
  const breakPoint = useMediaQuery();

  switch (breakPoint) {
    case 'xl':
    case 'lg':
    case 'md':
      return 'right';
    case 'sm':
    case 'xs':
      return 'top';
  }
}

export default useProgramPopoverPlacement;
